import './App.css';
import Header  from './layout/Header';
import Footer  from './layout/Footer';
import Sidebar from './layout/Sidebar';
import Content from './layout/Content';

function App() {
    return (
        <div className="App">
            <Header/>
            <Sidebar/>
            <Content/>
            <Footer/>
        </div>
    );
}

export default App;
